export const STATIC_MAP_PROXY_URLPATH = 'staticmap_https_proxy';
export const STATIC_MAP_PROXY_HOST_DEV = 'https://www.evbqa.com/';
export const STATIC_MAP_PROXY_HOST_PROD = '/';
export const STATIC_MAP_ZOOM = 16;
export const STATIC_MAP_HEIGHT = 280;
export const STATIC_MAP_SCALE = 2;
export const STATIC_MAP_STYLES = [
    'feature:all%7Celement:labels%7Cvisibility:off',
    'feature:administrative%7Celement:geometry.fill%7Ccolor:0xf5f5f5',
    'feature:administrative%7Celement:labels.text%7Clightness:15',
    'feature:administrative.locality%7Celement:labels.text.fill%7Clightness:-11',
    'feature:administrative.neighborhood%7Celement:labels%7Cvisibility:on',
    'feature:administrative.land_parcel%7Celement:all%7Cvisibility:simplified',
    'feature:landscape%7Celement:geometry.fill%7Ccolor:0xf5f5f5%7Clightness:-1',
    'feature:landscape.natural.terrain%7Celement:geometry.fill%7Cvisibility:off',
    'feature:poi%7Celement:labels%7Cvisibility:off',
    'feature:poi.business%7Celement:all%7Cvisibility:off',
    'feature:road%7Celement:labels%7Clightness:20%7Cvisibility:off',
    'feature:road.highway%7Celement:geometry%7Cvisibility:simplified%7Ccolor:0xffffff%7Clightness:15',
    'feature:road.highway.controlled_access%7Celement:geometry%7Cvisibility:simplified%7Chue:0xff6500%7Clightness:0',
    'feature:road.highway.controlled_access%7Celement:labels%7Cvisibility:off',
    'feature:road.arterial%7Celement:geometry%7Cvisibility:simplified%7Ccolor:0xffffff',
    'feature:road.arterial%7Celement:labels%7Cvisibility:on',
    'feature:road.local%7Celement:geometry%7Cvisibility:on',
    'feature:road.local%7Celement:geometry.stroke%7Cvisibility:on%7Ccolor:0xffffff%7Clightness:0',
    'feature:road.local%7Celement:labels%7Cvisibility:off%7Clightness:28',
    'feature:transit%7Celement:all%7Cvisibility:off%7Clightness:15',
    'feature:water%7Celement:all%7Chue:0x007bff%7Csaturation:30%7Clightness:49',
    'feature:water%7Celement:geometry%7Ccolor:0x39c2c9%7Csaturation:-20%7Cgamma:1.00%7Clightness:46',
    'feature:water%7Celement:labels%7Cvisibility:off',
];

export const STATIC_MAP_MARKER_ICON =
    'https://cdn.evbstatic.com/s3-build/perm_001/8d5543/django/images/create/auto-creation/map-pin.png';
